"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoginForm, _Component);

  function LoginForm() {
    (0, _classCallCheck3.default)(this, LoginForm);
    return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          email = _props$fields.email,
          password = _props$fields.password,
          handleSubmit = _props.handleSubmit,
          onSubmit = _props.onSubmit,
          auth = _props.auth;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "form",
          { id: "login", onSubmit: handleSubmit(onSubmit) },
          _react2.default.createElement(
            "div",
            { className: "row" },
            this.renderError(),
            this.renderSuccessMessage(),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6 input-group" },
              _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6 input-group" },
              _react2.default.createElement(_Input2.default, { id: "password", type: "password", label: "Salasana", fieldProps: password })
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/uusi-salasana", id: "passwordResetLink" },
            "Unohtuiko salasana?"
          ),
          _react2.default.createElement(_SubmitButton2.default, { text: "Kirjaudu", submitting: auth.loginLoading || false })
        )
      );
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var loginError = this.props.auth.loginError;

      if (loginError) {
        var text = void 0;
        if (loginError === "CONFIRMATION_NEEDED") {
          text = "Sähköpostiosoite on vahvistamatta. Ohjeet vahvistamiseen on lähetetty sähköpostiisi.";
        } else if (loginError === "INVALID_EMAIL_OR_PASSWORD") {
          text = "Väärä sähköpostiosoite tai salasana.";
        } else {
          text = "Valitettavasti kirjautuminen ei onnistunut. Yritä myöhemmin uudelleen.";
        }

        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-text-js" },
            text
          )
        );
      }
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      var _props$auth = this.props.auth,
          verifyEmailSuccess = _props$auth.verifyEmailSuccess,
          changePasswordSuccess = _props$auth.changePasswordSuccess;

      if (verifyEmailSuccess) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "S\xE4hk\xF6postiosoite vahvistettu. Voit nyt kirjautua sis\xE4\xE4n."
          )
        );
      }
      if (changePasswordSuccess) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "Salasanan vaihtaminen onnistui. Voit nyt kirjautua sis\xE4\xE4n uudella salasanallasi."
          )
        );
      }
    }
  }]);
  return LoginForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp);
exports.default = LoginForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/login/LoginForm.js
 ** module id = 1155
 ** module chunks = 0
 **/